import React, { useEffect, useContext } from 'react';
import styled from 'styled-components';
import { SEO, EventHero, EventAgenda, EventSponsor, Footer } from 'components';
import { graphql, navigate } from 'gatsby';
import { LocalContext, FirebaseContext } from 'context';

const eventRegistrationTemplate = ({ data, location }) => {
  const { setSelectedEvent } = useContext(LocalContext);
  const { user } = useContext(FirebaseContext);
  const { frontmatter: event } = data.markdownRemark;
  useEffect(() => {
    setSelectedEvent({
      name: event.name.replace('<br />', ' '),
      title: event.title,
      eid: event.eid,
      colors: event.colors,
      slug: event.slug
    });
    return () => {
      setSelectedEvent(null);
    };
  }, [event.eid]);

  useEffect(() => {
    if (user?.eventsUserCanAccess.includes(event.eid) || event.status === 'past') {
      navigate(`/events/${event.slug}/livestream`);
    }
  }, [user, event.status, event.eid]);

  return (
    <>
      <SEO
        pageSpecificTitle={event.title.replace('<br />', ' ')}
        pageSpecificDescription={event.description}
        pageSpecificThumbnail={
          event.socialThumbnail.childImageSharp.gatsbyImageData.images.fallback.src
        }
        pageSpecificThumbnailAlt={event.title.replace('<br />', ' ')}
      />
      <EventHero id="header" event={event} />
      <Container>
        <EventAgenda agenda={event.agenda} />
        <EventSponsor eventBroughtToYouBy={event.broughtToYouBy} />
      </Container>
      <Footer pathname={location.pathname} />
    </>
  );
};

const Container = styled.main`
  display: grid;
  gap: 3rem;
  grid-template-columns: repeat(6, 1fr);
  padding: 3rem 1.25rem;
  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(12, 1fr);
    padding: 6rem 0;
    gap: 6rem;
    margin: 0;
  }
`;

export const query = graphql`
  query ($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      id
      frontmatter {
        name
        slug
        status
        eid
        title
        subtitle
        cpdPoints
        background {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
        agenda {
          id
          time
          duration
          title
          description
        }
        inCollaborationWith {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
        broughtToYouBy {
          id
          name
          link
          image {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
            }
          }
        }
        socialThumbnail {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
        backgroundVideo
        description
        date
        start
        end
        location
        startTime
        endTime
      }
    }
  }
`;

export default eventRegistrationTemplate;
